// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","footerLabel":"Footer_footerLabel__El3B6"};